import { renderSlot as _renderSlot, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "x-toolbar"
};
import XToolbarItemGroup from './xToolbarItemGroup.vue';

import { computed } from 'vue';
const __default__ = {
  name: 'XToolbar'
};
export default /*@__PURE__*/Object.assign(__default__, {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  emits: ['item-click'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const toolbarItems = computed(() => {
      return props.items || [];
    });
    const handleItemClick = item => {
      emit('item-click', item);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_renderSlot(_ctx.$slots, "items", {}, () => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toolbarItems), (item, idx) => {
        return _openBlock(), _createBlock(XToolbarItemGroup, {
          key: `item_${idx}`,
          data: item,
          onItemClick: handleItemClick
        }, null, 8, ["data"]);
      }), 128))])]);
    };
  }
});